import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaChalkboardUser } from "react-icons/fa6";
import TrainingCourses from "./index";
// import ViewTrainingOverview from "./view";
// import EditTrainingOverview from "./edit";
import { MODULE_TRAINING } from "variables/constants";

const trainingCourseRoutes = [	
	generateCRUDRoutes({
		mainTitle: "My Courses",
		basePath: "training-courses",
		mainComponent: <TrainingCourses />,
	    layout: "/console",	   
	    icon: <FaChalkboardUser className="icon-item" />,
	    subTitle:"Training Courses",
	    // viewComponent: <ViewTrainingOverview />,
	    // createComponent: <EditTrainingOverview />,
	    // editComponent: <EditTrainingOverview />,
		level:5,
		moduleId: 0,
	})
]

export default trainingCourseRoutes;